/* =====================================================================
   Format monetaire unique du site — window.FOG_MONEY
   ---------------------------------------------------------------------
   Tout montant ecrit par un script passe par FOG_MONEY.format(). Le format
   n'est pas decide ici : il est calque sur le gabarit que Liquid produit
   avec le filtre `money` pour le marche courant (snippets/money-format.liquid).
   Un montant ecrit en JS a donc exactement la forme d'un montant ecrit par
   Liquid : « CHF 55.50 » en Suisse, « €50,00 » en Europe, et si la boutique
   change un jour son format dans l'admin, les scripts suivent sans retouche.

   Avant le 13 septembre 2026, trois formes coexistaient sur une meme page
   (Liquid, texte du widget SparkLayer, Intl du navigateur). Ne pas
   reintroduire de formateur local dans un script de section.

   Charge SANS defer en tete de <head> : les scripts de section qui s'en
   servent ne sont pas differes.
   ===================================================================== */

(function () {
  'use strict';

  var cfg = { currency: '', sample: '' };
  try {
    var node = document.getElementById('fog-money-format');
    if (node) cfg = JSON.parse(node.textContent || '{}');
  } catch (e) {}

  var CURRENCY = String(cfg.currency || '').toUpperCase();

  /* Ecrit `cents` avec la typographie du gabarit : position de la devise,
     separateur decimal, separateur de milliers. Renvoie null si le gabarit
     n'est pas exploitable. */
  function formatLike(template, cents) {
    var raw = String(template || '');
    var numMatch = raw.match(/\d(?:[\d\s'’.,]*\d)?/);
    if (!numMatch) return null;

    var num = numMatch[0];
    var decIndex = Math.max(num.lastIndexOf(','), num.lastIndexOf('.'));
    var decSep = '.';
    var groupSep = '';
    var hasDecimals = decIndex > -1 && num.length - decIndex - 1 === 2;

    if (hasDecimals) {
      decSep = num.charAt(decIndex);
      var g = num.slice(0, decIndex).match(/[\s'’.,]/);
      groupSep = g ? g[0] : '';
    } else {
      var g2 = num.match(/[\s'’.,]/);
      groupSep = g2 ? g2[0] : '';
    }

    var n = Math.round(Math.abs(Number(cents)));
    var units = String(Math.floor(n / 100));
    var rest = String(n % 100);
    if (rest.length < 2) rest = '0' + rest;
    if (groupSep) units = units.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);

    return raw.replace(num, hasDecimals ? units + decSep + rest : units);
  }

  function formatIntl(cents, currency) {
    var major = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(currency === 'CHF' ? 'fr-CH' : 'fr-FR', {
        style: 'currency', currency: currency
      }).format(major);
    } catch (e) {
      return major.toFixed(2) + ' ' + (currency || '');
    }
  }

  /* format(cents)            montant dans la devise du marche courant
     format(cents, currency)  idem, en precisant la devise du montant.
     Si cette devise n'est PAS celle du marche (tarif SparkLayer encore dans
     l'ancienne devise juste apres un changement de compte), on ne l'habille
     surtout pas avec le gabarit du marche, ce qui ferait lire « CHF 85.00 »
     pour 85 euros : repli sur Intl, qui ecrit la vraie devise. */
  function format(cents, currency) {
    if (cents == null || !isFinite(Number(cents))) return '';
    var cur = String(currency || CURRENCY).toUpperCase();
    var out = null;
    if (!CURRENCY || cur === CURRENCY) out = formatLike(cfg.sample, cents);
    if (!out) out = formatIntl(cents, cur || 'CHF');
    /* L'espace fine d'Intl (U+202F) tombe a 1,8 px dans la police du theme en
       petit corps : espace insecable ordinaire, qui reste visible. */
    return out.replace(/\u202F/g, '\u00A0');
  }

  window.FOG_MONEY = {
    currency: CURRENCY,
    sample: cfg.sample,
    format: format,
    formatLike: formatLike
  };
})();
